import { createAsyncThunk } from '@reduxjs/toolkit';
import { BannersAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { BANNERS_SLICE_NAME } from './models';
import {
  IBannerListResponse,
  ICreateBannerDTO,
  ICreateBannerResponse,
  IGetBannersListDTO,
  IReorderBannersDTO,
} from '@/models/banners.model';

export const getBannersList = createAsyncThunk<
  IBannerListResponse,
  IGetBannersListDTO,
  { serializedErrorType: IApiError }
>(
  `${BANNERS_SLICE_NAME}/getBannersList`,
  async (data) => {
    const response = await BannersAPI.getBannersList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const reorderBanners = createAsyncThunk<
  IBannerListResponse,
  IReorderBannersDTO,
  { serializedErrorType: IApiError }
>(
  `${BANNERS_SLICE_NAME}/reorderBanners`,
  async (data) => {
    const response = await BannersAPI.reorderBanners(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createBanner = createAsyncThunk<
  ICreateBannerResponse,
  ICreateBannerDTO,
  { serializedErrorType: IApiError }
>(
  `${BANNERS_SLICE_NAME}/createBanner`,
  async (data) => {
    const response = await BannersAPI.createBanner(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getBanner = createAsyncThunk<ICreateBannerResponse, string, { serializedErrorType: IApiError }>(
  `${BANNERS_SLICE_NAME}/getBanner`,
  async (data) => {
    const response = await BannersAPI.getBanner(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteBanner = createAsyncThunk<undefined, string, { serializedErrorType: IApiError }>(
  `${BANNERS_SLICE_NAME}/deleteBanner`,
  async (id) => {
    const response = await BannersAPI.deleteBanner(id);
    return response.data?.data;
  },
  { serializeError: formatApiError },
);

export const editBanner = createAsyncThunk<
  ICreateBannerResponse,
  { id: string; data: ICreateBannerDTO },
  { serializedErrorType: IApiError }
>(
  `${BANNERS_SLICE_NAME}/editBanner`,
  async ({ id, data }) => {
    const response = await BannersAPI.editBanner(id, data);
    return response.data;
  },
  { serializeError: formatApiError },
);
